import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import type { User } from '@supabase/supabase-js'
import { NotFound } from '@/components/NotFound'
import { CookieConsent } from '@/components/CookieConsent'

export interface RouterContext {
  auth: {
    user: User | null
    isLoading: boolean
    hasOnboarded: boolean | null
  }
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <CookieConsent />
    </>
  ),
  notFoundComponent: NotFound,
})
